import { useEffect, useRef, useState } from "react";
import { MdArrowBack, MdArrowLeft, MdArrowRight, MdAttachFile, MdClose, MdFileCopy, MdFilePresent, MdForward, MdForward10, MdForwardToInbox, MdReply, MdSend } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { researcherMailConst, web_url } from "../../constant";


function EmailView({ t, lang }) {
    const penpalEmail = localStorage.getItem('penpalEmail');
    const teacherEmail = localStorage.getItem('teacherEmail');
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });

    const [content, setContent] = useState({
        messageId: "",
        threadId: "",
        subject: "",
        other: '',
        type: '',
        attachments: [],
        approvedAttachments: []
    });


    const [messagesArray, setmessagesArray] = useState([
        {
            messageId: "",
            sender: "",
            body: "",
            status: "",
            sentAt: "",
            language: "",
            type: "",
            attachments: [],
            approvedAttachments: [],
            otherPerson: "",
            receiver: ''
        }
    ])
    const [indexOfMessageShowingNow, setIndexOfMessageShowingNow] = useState(0)

    const [isReceived, setIsReceived] = useState(false);

    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();

    useEffect(() => {
        if (localStorage.getItem('mailsent')) {
            const mail = JSON.parse(localStorage.getItem('mailsent'));
            setContent(mail)
        } else if (localStorage.getItem('maildraft')) {
            const mail = JSON.parse(localStorage.getItem('maildraft'));
            setContent(mail)
        } else if (localStorage.getItem('mailreceived')) {
            const mail = JSON.parse(localStorage.getItem('mailreceived'));
            setContent(mail)
        } else {
            alert("no mail")
        }
    }, [])

    useEffect(() => {
        if (logDetails) {
            if (messagesArray) {
                if (messagesArray[indexOfMessageShowingNow]?.receiver === logDetails.email) {
                    // console.log("abi idiot 1");
                    setIsReceived(true)
                } else {
                    // console.log("abi idiot 2");
                    setIsReceived(false)
                }
            }
        }
    }, [indexOfMessageShowingNow, messagesArray])

    useEffect(() => {

        console.log('received', isReceived);

    }, [isReceived])

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };


    useEffect(() => {
        if (logDetails) {
            setIsLoading(true);
            if (content.threadId) {

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails.token}`,
                    },
                };
                axios.get(`${web_url}/api/email-threads/${content.threadId}`, configToken).then((response) => {
                    // console.log("resnow", response.data);

                    const sortedMessages = response.data.messages
                        .filter(message => (message.sender === logDetails.email) || (message.status === "APPROVED")) // Keep only messages with moderationRecord
                        .sort((a, b) => new Date(a.sentAt) - new Date(b.sentAt)) // Sort by sentAt date
                        .map((message) => ({
                            ...message,
                            receiver: response.data.participants.find(email => email !== message.sender)
                        }));

                    // console.log("sorted", sortedMessages);

                    setmessagesArray(sortedMessages);
                    setIsLoading(false);


                }).catch((err) => {
                    handleClickOpenError('error occured')
                    setIsLoading(false);
                })
            }
        }
    }, [content])
    // console.log("this is tha response", messagesArray);
    // useEffect(() => {
    //     console.log("arra", messagesArray.length);

    // }, [messagesArray])

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }], // Header options (H1, H2, and normal text)
            ['bold', 'italic', 'underline'], // Inline styles
            [{ list: 'ordered' }, { list: 'bullet' }], // Ordered and unordered lists
        ],
    };

    // const formats = ["bold", "italic", "underline", "list", "bullet", "size"];

    const navigate = useNavigate();

    const [showLeftArrow, setShowLeftArrow] = useState(false)
    const [showRightArrow, setShowRightArrow] = useState(false)

    // useEffect(() => {
    //     console.log("index", indexOfMessageShowingNow);
    //     console.log("lenght", messagesArray.length);

    // }, [indexOfMessageShowingNow])

    useEffect(() => {
        if (messagesArray) {
            if (messagesArray.length === 1) {
                setShowLeftArrow(false);
                setShowRightArrow(false);
                setIndexOfMessageShowingNow(0);
            } else {
                const index = messagesArray.findIndex((message) => message.messageId === content.messageId);
                setIndexOfMessageShowingNow(index);
            }
        }
    }, [messagesArray])

    useEffect(() => {
        if (messagesArray.length === 1) {
            setShowLeftArrow(false);
            setShowRightArrow(false);
            setIndexOfMessageShowingNow(0);
        } else {
            if (indexOfMessageShowingNow === (messagesArray.length) - 1) {
                setShowRightArrow(false);
            } else {
                setShowRightArrow(true);
            }

            if (indexOfMessageShowingNow === 0) {
                setShowLeftArrow(false);
            } else {
                setShowLeftArrow(true);
            }
        }

        // console.log('message', messagesArray[indexOfMessageShowingNow]);

    }, [indexOfMessageShowingNow, messagesArray])

    const handleRightArrow = () => {
        setIndexOfMessageShowingNow(indexOfMessageShowingNow + 1);
    }

    const handleLeftArrow = () => {
        setIndexOfMessageShowingNow(indexOfMessageShowingNow - 1);
    }

    const handleReplyButton = () => {
        console.log('content', content);

        const mailRequest = {
            type: 'old',
            threadId: content.threadId,
            subject: content.subject,
            to: isReceived ? content.sender : content.other,
            role: content.type
        };
        localStorage.setItem('threadId', JSON.stringify(mailRequest));
        if (isXlOrLarger) {
            navigate('/desktop/student/mailbox');
        } else {
            navigate('/mobile/student/mailbox/composemail');
        }
    }

    const handleDownload = async (fileName, fileUrl) => {
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };


    const [showReplyButton, setShowReplyButton] = useState(true);

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            console.log('m arra: ', messagesArray);

            let sendersArray = [];
            let othersArray = [];
            if (messagesArray.length > 0) {
                sendersArray = messagesArray.map(message => message.sender);
                othersArray = messagesArray.flatMap(({ receiver, otherPerson, sender }) =>
                    [receiver, otherPerson, sender].filter(Boolean)
                );

            }
            if (sendersArray.includes(logDetails.email) && othersArray.includes(researcherMailConst)) {
                setShowReplyButton(false);
            } else {
                setShowReplyButton(true);
            }
        }
    }, [messagesArray])

    return (
        <>
            <div className="xl:bg-[#FFEBA9] xl:rounded-md mb-[200px] xl:mb-[10px] pl-[30px] xl:pl-[20px] xl:ml-[0px] 2xl:pl-[30px] pr-[30px] xl:pr-[20px] 2xl:pr-[30px] xl:mr-[80px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[1px] 2xl:pt-[5px] xl:pb-[20px] 2xl:pb-[30px] 2xl:pt-[0px] xl:mt-[20px] 2xl:mt-[30px]">
                <div className="flex w-full items-center justify-center">
                    <div className="flex items-center mt-[20px] justify-between w-full md:w-[600px]">
                        <div className="flex items-center justify-between w-full ">
                            <div className="flex items-center">
                                <MdArrowBack size={25} className="md:hidden" onClick={() => {
                                    navigate('/mobile/student/mailbox')
                                }} />
                                <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                                    navigate('/mobile/student/mailbox')
                                }} />
                                {/* <p className="font-bold text-[20px] ml-[10px] md:text-[20px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t234')}</p> */}
                                <p className={`font-bold ml-[10px] ${lang === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]")}`}>{t('t234')}</p>
                            </div>
                            <div className="flex items-center">

                                {
                                    showReplyButton &&
                                    <>
                                        <button className={`px-[20px] py-[8px] gap-[10px] bg-[#0E141F] text-[#ffffff] hover:bg-[#0E141F] hover:bg-opacity-20 hover:text-[#1E2533]  ${lang === "en" ? "text-[14px] md:text-[18px] lg:text-[24px] xl:text-[15px] 2xl:text-[22px]" : (lang === "si" ? "text-[12px] md:text-[15px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]" : "text-[12px] md:text-[16px] lg:text-[19px] xl:text-[13px] 2xl:text-[18px]")} rounded-md  border border-1  border-[#0E141F] font-[600]`}
                                            onClick={handleReplyButton}>{t('t260')}</button>
                                    </>
                                }

                            </div>
                        </div>
                    </div>

                </div>
                <div className="flex items-center justify-center w-full">
                    <div className="flex items-center w-full md:w-[600px] justify-end">
                        <div className="flex items-center mt-[10px]">
                            {
                                showLeftArrow &&
                                <>
                                    <MdArrowLeft onClick={handleLeftArrow} size={40} className="md:hidden" />
                                    <MdArrowLeft onClick={handleLeftArrow} size={50} className="hidden md:block" />
                                </>
                            }

                            {
                                showRightArrow &&
                                <>
                                    <MdArrowRight onClick={handleRightArrow} size={40} className="md:hidden" />
                                    <MdArrowRight onClick={handleRightArrow} size={50} className="hidden md:block" />
                                </>
                            }
                        </div>
                    </div>
                </div>
                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="flex items-center justify-center">
                                <div className="w-full md:w-[600px] items-center mt-[10px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    {isReceived &&
                                        <p className={`text-gray-500 text-[15px]`}>{t('t235')}:</p>
                                    }
                                    {!isReceived &&
                                        <p className={`text-gray-500 text-[15px]`}>{t('t220')}:</p>
                                    }
                                    {messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow]?.sender &&
                                        isReceived &&
                                        <input
                                            value={messagesArray[indexOfMessageShowingNow].sender ? (messagesArray[indexOfMessageShowingNow].sender === penpalEmail ? "Penpal" : (messagesArray[indexOfMessageShowingNow].sender === teacherEmail ? "Teacher" : (messagesArray[indexOfMessageShowingNow].sender === researcherMailConst ? "Admin" : "Old Penpal"))) : ""}
                                            readOnly type="text" name="receptionist" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                        />
                                    }
                                    {
                                        messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] &&
                                        !isReceived && (
                                            <input
                                                value={messagesArray[indexOfMessageShowingNow].receiver ? (messagesArray[indexOfMessageShowingNow].receiver === penpalEmail ? "Penpal" : (messagesArray[indexOfMessageShowingNow].receiver === teacherEmail ? "Teacher" : (messagesArray[indexOfMessageShowingNow].receiver === researcherMailConst ? "Admin" : "Old Penpal"))) : ""}
                                                readOnly
                                                type="text"
                                                name="receptionist"
                                                className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                            />
                                        )
                                    }
                                </div>
                            </div>

                            <div className="flex items-center justify-center">
                                <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                                    <input readOnly
                                        value={messagesArray[0].sender === penpalEmail ? (content.translatedSubject ? content.translatedSubject : "No subject") : (content.subject ? content.subject : "No subject")}
                                        type="text" name="subject" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] ${content.subject.trim() ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t224')}
                                    />
                                </div>
                            </div>
                            {/* {isReceived &&
                                        <p className={`text-gray-500 text-[15px]`}>{t('t235')}:</p>
                                    } */}
                            <div className="mt-[20px] md:pl-[100px] lg:pl-[200px] xl:pl-[10px] flex flex-col gap-[5px] mb-[10px]">
                                {
                                    messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.attachments && messagesArray[indexOfMessageShowingNow]?.type !== "PENPAL" &&
                                    <>
                                        {(messagesArray[indexOfMessageShowingNow].attachments).map((file, index) => (
                                            <div key={index} className="flex items-center justify-between">
                                                <div className="flex items-center cursor-pointer" onClick={() => handleDownload((file.fileName, file.fileUrl))}>
                                                    <MdFilePresent />
                                                    <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                </div>

                                            </div>
                                        ))}
                                    </>
                                }
                                {
                                    messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.type === "PENPAL" && messagesArray[indexOfMessageShowingNow]?.approvedAttachments && isReceived &&
                                    <>
                                        {(messagesArray[indexOfMessageShowingNow].approvedAttachments).map((file, index) => (
                                            <div key={index} className="flex items-center justify-between">
                                                <div className="flex items-center cursor-pointer" onClick={() => handleDownload((file.fileName, file.fileUrl))}>
                                                    <MdFilePresent />
                                                    <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                </div>

                                            </div>
                                        ))}
                                    </>
                                }
                                {
                                    messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.type === "PENPAL" && messagesArray[indexOfMessageShowingNow]?.attachments && !isReceived &&
                                    <>
                                        {(messagesArray[indexOfMessageShowingNow].attachments).map((file, index) => (
                                            <div key={index} className="flex items-center justify-between">
                                                <div className="flex items-center cursor-pointer" onClick={() => handleDownload((file.fileName, file.fileUrl))}>
                                                    <MdFilePresent />
                                                    <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                </div>

                                            </div>
                                        ))}
                                    </>
                                }
                            </div>

                            <div className="md:flex md:justify-center md:items-center">
                                {
                                    messagesArray.length > 0 && messagesArray[indexOfMessageShowingNow] && messagesArray[indexOfMessageShowingNow]?.body &&
                                    <div className="justify-center items-center w-full md:w-[600px]">
                                        <ReactQuill
                                            modules={{ toolbar: false }}
                                            value={messagesArray[indexOfMessageShowingNow].sender === penpalEmail ? messagesArray[indexOfMessageShowingNow].translatedBody : messagesArray[indexOfMessageShowingNow].body}
                                            readOnly
                                            theme="snow"
                                            placeholder={t('t225')}
                                            className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                                    </div>
                                }
                            </div>
                        </>
                }

            </div >

        </>
    )
}

export default EmailView;
